import firebase from 'firebase/app';
import 'firebase/database';

import config from 'config/firebase.json';

firebase.initializeApp(config);



// WEBPACK FOOTER //
// ./src/init/firebase.js